// src/hooks/useEliminarUsuario.js
import axios from "axios";

const API_BASE_URL =
  (typeof import.meta !== "undefined" &&
    import.meta.env &&
    import.meta.env.VITE_API_URL) ||
  process.env.REACT_APP_API_URL ||
  "";

export default function useEliminarUsuario() {
  return async function eliminarUsuario(id) {
    const authToken = localStorage.getItem("token");
    await axios.delete(`${API_BASE_URL}/api/usuarios/${id}`, {
      headers: { Authorization: `Bearer ${authToken}` },
    });
  };
}
